/* eslint-disable */
import Vue from "vue";
import Vuex from "vuex";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import vuescroll from "vue-scroll";
import axios from "axios";
import "es6-promise/auto";
import store from "./stores";
import VueWebP from "v-webp";
import VueRecaptcha from "vue-recaptcha";

Vue.use(vuescroll);
Vue.use(axios);
Vue.use(Vuex);
Vue.config.productionTip = false;
Vue.use(VueWebP);
import VideoBg from "vue-videobg";
Vue.component("video-bg", VideoBg);
Vue.component("vue-recaptcha", VueRecaptcha);

new Vue({
  store,
  router,
  vuetify,
  render: (h) => h(App),
}).$mount("#app");
